import { useRemoteResource } from "hooks/useRemoteResource";
import withRouter from "hoc/withRouter";
import { CircularProgress } from "@mui/material";
import offersService from "services/admin/offersService";
import ProductCard from "components/ProductCard/ProductCard";
import ListPage from "components/ListPage/ListPage";

const ProductList = () => {
    const [data, loadData, loading, error] = useRemoteResource(offersService.getAll, "");

    function buildContent() {
        if (error) {
            return <div>{error}</div>
        }
        if (loading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }
        if (data.data.length === 0) {
            return <div>Товары отсутсвуют. Чтобы добавить товар пожалуйста нажмите на кнопку "Добавить" сверху</div>
        }
        if (data.data.length > 0) {
            return data.data.map((o, inx) => {
                return <div key={inx} className="m-b-16">
                    <ProductCard offer={o} loadData={loadData} options={{ hideButtons: o.status === "AVAILABLE" ? false : true }}></ProductCard>
                </div>
            })
        }
    }
    return (
        <ListPage pageTitle="Список товаров" pathToAdd="../add">
            <div className="m-t-32">
                {buildContent()}
            </div>
        </ListPage>

    );
};

export default withRouter(ProductList);
